import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorCorporateCategoryCustomerUpdate = () => {
  const categoryCustomerUpdate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }
    const isAlert = body.alert ?? false
    delete payload.alert
    ApiService.jsonRequest('/corporate/category-customer/update', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        if (isAlert) {
          showAlert({
            icon: 'success',
            message:
              payload.is_deleted === 'Y'
                ? getTranslate('message.successfully_deleted')
                : getTranslate('message.successfully_updated'),
            timer: 2000,
            redirect: '/company/category-customer/manage',
          })
        }
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])
  return { categoryCustomerUpdate }
}

export default InteractorCorporateCategoryCustomerUpdate
